import { Modal, Input } from 'antd';
import { Form, Button, Space } from 'antd';
import './index.less';

export default ({
  visible,
  required = false,
  title = '审核驳回理由',
  onOk = () => {},
  onCancel = null,
  okText = '确定',
  cancelText = '取消',
  width = 333,
  okButtonProps = {},
  cancelButtonProps = {},
  max = 50,
  ...props
}) => {
  const [form] = Form.useForm();

  function cancel() {
    if (onCancel === null) return;
    form.resetFields();
    onCancel();
  }

  return (
    <Modal
      width={width}
      title={title}
      visible={visible}
      okText={okText}
      cancelText={cancelText}
      onCancel={cancel}
      footer={
        <div className="TY_reject-reason-btn">
          <Space size={8}>
            <Form.Item noStyle>
              <Button onClick={cancel} shape="round" {...cancelButtonProps}>
                {cancelText}
              </Button>
            </Form.Item>
            <Form.Item noStyle>
              <Button
                type="primary"
                htmlType="submit"
                shape="round"
                {...okButtonProps}
                onClick={() => {
                  form
                    .validateFields()
                    .then((res) => {
                      onOk(form.getFieldValue('reason'));
                      form.resetFields();
                    })
                    .catch(() => {});
                }}
              >
                {okText}
              </Button>
            </Form.Item>
          </Space>
        </div>
      }
      {...props}
    >
      <Form form={form} validateTrigger="onBlur">
        <Form.Item
          name="reason"
          rules={
            required
              ? [
                  {
                    required: true,
                    message: '不能为空！',
                  },
                  {
                    max,
                    message: `不能超出${max}个字！`,
                  },
                ]
              : [
                  {
                    max,
                    message: `不能超出${max}个字！`,
                  },
                ]
          }
        >
          <Input.TextArea rows={5} placeholder={`请输入驳回理由，不超过${max}字`} />
        </Form.Item>
      </Form>
    </Modal>
  );
};
